import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IContactUsApiResponse, IContactUsReqData } from '../../types/api/contactUsApi';
import { IContactUsState } from '../../types/features/contactUsSlice';
import { submitContactUsDataService, submitFeedbackDataService } from '../../api/contactUsApi';


export const submitContactUsData = createAsyncThunk<IContactUsApiResponse, IContactUsReqData>(
    'contactUs/submitContactUsData',
    async (data: IContactUsReqData) => {
        const response = await submitContactUsDataService(data);
        return response.data; // Assumes response has a 'data' property
    }
);

export const submitFeedbackData = createAsyncThunk<IContactUsApiResponse, FormData>(
    'contactUs/submitFeedbackData',
    async (data: FormData) => {
        const response = await submitFeedbackDataService(data);
        return response.data; // Assumes response has a 'data' property
    }
);

const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState: {
        contactUsLoader: false,
        feedbackLoader: false,

        status: false,
        msg: '',
    } as IContactUsState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitContactUsData.pending, (state) => {
                state.contactUsLoader = true;
            })
            .addCase(submitContactUsData.fulfilled, (state, action: PayloadAction<IContactUsApiResponse>) => {
                state.msg = action.payload.message;
                state.status = true;
                state.contactUsLoader = false;
            })
            .addCase(submitContactUsData.rejected, (state, action) => {
                state.contactUsLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

            .addCase(submitFeedbackData.pending, (state) => {
                state.feedbackLoader = true;
            })
            .addCase(submitFeedbackData.fulfilled, (state, action: PayloadAction<IContactUsApiResponse>) => {
                state.msg = action.payload.message;
                state.status = true;
                state.feedbackLoader = false;
            })
            .addCase(submitFeedbackData.rejected, (state, action) => {
                state.feedbackLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default contactUsSlice.reducer;
